import ToolStylus from './ToolStylus';
import promoImage from '../assets/promotions/wireframe_popover.svg';

class ToolStylusWireframePromo extends ToolStylus {
  static toolName = 'Try wireframes';

  static popover() {
    return {
      title: 'Create wireframes',
      description: 'Craft new user experiences with a library of components.',
      image: promoImage,
    };
  }

  static action() {
    return true;
  }
}

export default ToolStylusWireframePromo;
